module.exports = __webpack_public_path__ + "static/telecommute-chat-02dbf35cdad82efd60aa6d2c15b6941b.png";